import { Image, LI, UL } from "../../../../AbstractElements";
import { CALL_DATA } from "../../../../Data/Chat";
import { dynamicImage } from "../../../../Service/DynamicImage";

const PeopleList = () => {
  return (
    <div className="people-list">
      <UL className="list custom-scrollbar simple-list">
        {CALL_DATA.map((data, index) => (
          <LI className="clearfix" key={index}>
            <Image className="rounded-circle user-image" src={dynamicImage(`user/${data.imageNumber}.jpg`)} alt="call-user"/>
            <div className="about">
              <div className="name">{data.name}</div>
              <div className="status">{data.icon}{data.date}</div>
            </div>
          </LI>
        ))}
      </UL>
    </div>
  );
};

export default PeopleList;
